var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 7.33317H15.5832V5.49984C15.5832 2.96984 13.5298 0.916504 10.9998 0.916504C8.46984 0.916504 6.4165 2.96984 6.4165 5.49984V7.33317H5.49984C4.4915 7.33317 3.6665 8.15817 3.6665 9.1665V18.3332C3.6665 19.3415 4.4915 20.1665 5.49984 20.1665H16.4998C17.5082 20.1665 18.3332 19.3415 18.3332 18.3332V9.1665C18.3332 8.15817 17.5082 7.33317 16.4998 7.33317ZM10.9998 15.5832C9.9915 15.5832 9.1665 14.7582 9.1665 13.7498C9.1665 12.7415 9.9915 11.9165 10.9998 11.9165C12.0082 11.9165 12.8332 12.7415 12.8332 13.7498C12.8332 14.7582 12.0082 15.5832 10.9998 15.5832ZM13.8415 7.33317H8.15817V5.49984C8.15817 3.93234 9.43234 2.65817 10.9998 2.65817C12.5673 2.65817 13.8415 3.93234 13.8415 5.49984V7.33317Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cba563ea3bf826aa3f7ab310c9c8b54e.svg";
export { ForwardRef as ReactComponent };